import { Dictionary } from "lodash";
import * as React from "react";
import { Observer } from "rxjs/internal/types";

export type TChildrenRender<TProps> = (props: TProps) => JSX.Element | null;

export enum FieldActionTypes {
  register = "@@FORM_REGISTER_FIELD",
  change = "@@FORM_CHANGE",
  focus = "@@FORM_FOCUS",
  blur = "@@FORM_BLUR",
  destroy = "@@FORM_DESTROY_FIELD"
}

type TErrorMsg = string | undefined;
export type TFieldValue = any;
export type TValidator = (value: TFieldValue) => TErrorMsg;

export interface IFieldInnerProps extends IFieldState {
  name: string;
  onChange: (value: React.MouseEvent | TFieldValue) => void;
  onBlur: (value: React.MouseEvent | TFieldValue) => void;
  onFocus: () => void;
}

export interface IFieldMeta {
  dirty?: boolean;
  touched?: boolean;
  visited?: boolean;
  error?: TErrorMsg;
  warning?: string | undefined;
  required?: boolean;
  completed?: boolean;
  meetRequired?: boolean;
  defaultValue?: any;
}

export interface IFieldState {
  value?: TFieldValue;
  meta: IFieldMeta;
}

export interface IFieldAction {
  name: string;
  type: FieldActionTypes;
  meta?: IFieldMeta & { destroyValueOnUnmount?: boolean };
  payload?: TFieldValue;
}

export interface IFormContextValue {
  dispatch: (fieldAction: IFieldAction | IFormAction) => any;
  subscribeFormAction: (observer: Observer<any>) => any;
  subscribe: (observer: Observer<any>) => any;
  updateFormValues: (formValues: IFormValues) => any;
  updateFormState: (formState: IFormState) => any;
  getFormValues: () => IFormValues;
  getFormState: () => IFormState;
  fieldPrefix?: string;
}

export interface IFields {
  [fieldName: string]: IFieldMeta;
}

export interface IFormValues {
  [fieldName: string]: TFieldValue;
}

export interface IFormMeta {
  submitting: boolean;
  changed: boolean;
  completed: boolean;
}

export type TErrors = Dictionary<string | undefined>;

export interface IFormAction {
  type: string;
}

export enum FormActionTypes {
  startSubmit = "@@FORM_START_SUBMIT",
  endSubmit = "@@FORM_END_SUBMIT",
  reset = "@@FORM_RESET"
}

export interface IFormState {
  fields: IFields;
  values: IFormValues;
  meta: IFormMeta;
}
